
const LoadingElement = ({ height = "100vh"}) => {
  return (
    <div className="d-flex justify-content-center align-items-center"
      style={{ height }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default LoadingElement;